import { DO_NOT_USE_FaWrapper } from '../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { StyledButton, StyledIconContainer, StyledFadeOutSpacer } from './styled.js';
import { FadeOutContainer } from '../components/index.js';
import { useSidebarMenu } from '../useSidebarMenu/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Chip } from '../../../dataDisplay/Chip/Chip.js';

function SidebarMenuSearch(props) {
  var label = props.label,
    shortcutLabel = props.shortcutLabel,
    onClick = props.onClick;
  var _useSidebarMenu = useSidebarMenu(),
    minimized = _useSidebarMenu.minimized;
  return /*#__PURE__*/jsxs(StyledButton, {
    $minimized: minimized,
    appearance: "secondary",
    onClick: onClick,
    children: [/*#__PURE__*/jsx(StyledIconContainer, {
      children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
        icon: faSearch
      })
    }), /*#__PURE__*/jsx(FadeOutContainer, {
      $minimized: minimized,
      children: /*#__PURE__*/jsxs(StyledFadeOutSpacer, {
        children: [label, /*#__PURE__*/jsx(Chip, {
          appearance: "secondary",
          label: shortcutLabel
        })]
      })
    })]
  });
}

export { SidebarMenuSearch };
